import HttpService from './HttpService';
import BotStartMessage from '../models/BotStartMessage';
import PostQueryRequest from '../models/PostQueryRequest';
import { FeedbackRequest } from '../models/FeedbackRequest';
import { IResponse } from '../models/IResponse';
import IFeedbackResponse from '../models/IFeedbackResponse';
import IBotService from '../interfaces/IBotService';
import { ChatMode } from '../enums/ChatMode';
import IConversationResponse from '../models/IConversationResponse';
import { QueryResponse } from '../models/QueryResponse';
export default class BotService implements IBotService {
    readonly apiUrl: string;
    constructor(apiUrl: string) {
        this.apiUrl = apiUrl;
    }

    public getBotStartMessage(chat_mode: string): Promise<BotStartMessage> {
        return HttpService.getRequest<BotStartMessage>(`${this.apiUrl}/api/conversation/init`, { chat_mode });
    }

    public createBotStartMessage(data: BotStartMessage): Promise<BotStartMessage> {
        return HttpService.postRequest<BotStartMessage, BotStartMessage>(`${this.apiUrl}/api/conversation/init`, data);
    }

    public postQuery(data: PostQueryRequest): Promise<IResponse> {
        return HttpService.postRequest<PostQueryRequest, IResponse>(`${this.apiUrl}/api/conversation`, data);
    }

    public postFeedback(data: FeedbackRequest): Promise<IFeedbackResponse> {
        return HttpService.postRequest<FeedbackRequest, IFeedbackResponse>(
            `${this.apiUrl}/api/conversation/message_feedback`,
            data
        );
    }
    public getConversations(chat_mode: ChatMode, offset: number, limit: number): Promise<IConversationResponse[]> {
        return HttpService.getRequest<IConversationResponse[]>(`${this.apiUrl}/api/conversation`, { chat_mode, offset, limit });
    }
    public getConversationHistory(conversation_id: string, chat_mode: ChatMode): Promise<QueryResponse> {

        return HttpService.getRequest<QueryResponse>(`${this.apiUrl}/api/conversation/history`, { conversation_id, chat_mode });

    }
}

